export default {
  title: "[[hwr]]",
  number: "Nr.",
  general: {
    billedAt: "Zuletzt abgerechnet",
    draftedAt: "Letzter Abrechnungsentwurf erstellt",
    lastPrintedAt: "Zuletzt gedruckt",
  },
  form: {
    general: {
      categories: "Kategorien",
      startdate: "Ausführungsdatum",
      description: "Beschreibung der Leistungen",
      tags_included: "Tags inbegriffen",
      // "TLS zum BTB anhängen". Angehängt heißt: die Arbeit steckt schon im Bautagesbericht, die
      // Nachkalkulation zählt diesen Bericht deshalb nirgends mit.
      attachment: {
        label: "[[cr:Zum/Zur/Zum]] [[cr]] anhängen",
        project_default: "Projektstandard",
        attached: "Anhängen",
        separate: "Nicht anhängen",
        hint_attached:
          "Die Kosten sind [[cr:im/in der/im]] [[cr]] enthalten. Die Nachkalkulation führt den Bericht auf, zählt ihn aber nicht noch einmal.",
        hint_attached_no_report:
          "Das Projekt hat noch [[cr:keinen/keine/kein]] [[cr]]. Bis es [[cr:einen/eine/eins]] gibt, zählt die Nachkalkulation die Kosten separat.",
        hint_attached_refused:
          "Das Projekt hat noch [[cr:keinen/keine/kein]] [[cr]]. Zum Speichern bitte zuerst [[cr:einen/eine/eins]] anlegen oder „Nicht anhängen“ wählen.",
        hint_attached_unknown:
          "Sobald das Projekt [[cr:einen/eine/ein]] [[cr]] hat, sind die Kosten darin enthalten und zählen nicht noch einmal. Bis dahin zählt die Nachkalkulation sie separat.",
        hint_separate: "Die Kosten werden in der Nachkalkulation separat gezählt.",
        construction_report: "[[cr]]",
        construction_report_optional: "[[cr]] (optional)",
        construction_report_hint:
          "Ohne Auswahl wird [[cr:der/die/das]] [[cr]] beim Speichern nach dem Ausführungsdatum bestimmt.",
        construction_report_automatic_hint:
          "Automatisch nach dem Ausführungsdatum bestimmt. Hier lässt sich [[cr:ein anderer/eine andere/ein anderes]] wählen.",
        construction_report_empty: "Keine [[cr.pl]] gefunden",
      },
    },
    list_empty_hint: "Über das Feld oben suchen und auswählen.",
    machines: {
      // Eine Zeile bucht ein Gerät; dasselbe Gerät zweimal zum selben Preis würde keinen Tag mehr abrechnen.
      duplicate_device: "Zu diesem Preis bereits gebucht: Geräte-Nr. {devices}. Bitte die vorhandene Zeile ändern.",
      machine: "Maschine auswählen",
      machine_label: "Maschine",
      add_machine: "Fügen Sie eine Maschine hinzu",
      amount: "Menge",
      duration: "Dauer",
      duration_each: "Je Gerät",
      // Eine Zeile von früher, die mehrere Geräte ohne Nummer zählte, wird beim Bearbeiten zu einer Zeile je Gerät.
      legacy_amount_hint:
        "Bisher als {amount} Stück ohne Geräte-Nummer erfasst. Jetzt steht jede Zeile für ein Gerät: bitte die Geräte-Nummern angeben.",
      duration_unit: "Einheit der Dauer",
      billed: "= {quantity} {unit} abgerechnet (angefangener Einsatztag)",
      // Eine Preiszeile je Woche oder Monat: der Anteil der Einsatztage an den Miettagen des Lieferanten.
      billed_week:
        "= {quantity} Woche abgerechnet ({days} von {per} Miettagen) | = {quantity} Wochen abgerechnet ({days} von {per} Miettagen)",
      billed_month:
        "= {quantity} Monat abgerechnet ({days} von {per} Miettagen) | = {quantity} Monate abgerechnet ({days} von {per} Miettagen)",
      unit_unresolved:
        "Für „{legacy}“ ist noch keine Abrechnungseinheit festgelegt. Bitte zuerst in den Maschinen-Stammdaten Stunde oder Tag wählen.",
      legacy_duration_hint:
        "Bisher erfasst: {previous}. Die Dauer wird jetzt in Stunden angegeben. Bitte neu eintragen.",
      amount_unit: "Stück",
      list_title: "Maschinen",
      list_empty: "Noch keine Maschinen hinzugefügt",
    },
    materials: {
      material: "Material auswählen",
      add_material: "Fügen Sie ein Material hinzu",
      amount: "Menge",
      list_title: "Materialien",
      list_empty: "Noch keine Materialien hinzugefügt",
    },
    additional_efforts: {
      additional_effort: "Zusätzliche Leistung auswählen",
      add_additional_effort: "Fügen Sie eine Zusätzliche Leistung hinzu",
      amount: "Menge",
      list_title: "Zusätzliche Leistungen",
      list_empty: "Noch keine zusätzlichen Leistungen hinzugefügt",
    },
    users: {
      user: "Personal auswählen",
      add_user: "Fügen Sie ein Personal hinzu",
      duration: "Dauer",
      positions: "Positionen",
      no_positions: "Keine Positionen verfügbar",
      assigned: "Zugewiesen",
      from_project: "Projekt",
      // Beim Speichern übernimmt der Server die Position ins Projekt — ohne Stundensatz, denn
      // der ist eine kaufmännische Entscheidung. Den fehlenden Satz meldet der Reiter im Projekt. Gesagt wird
      // die Position, nicht die Person: „Neu im Projekt“ las sich, als käme der Mitarbeiter neu hinzu.
      not_in_project: "Position kommt neu ins Projekt.",
      list_title: "Personal",
      list_empty: "Noch kein Personal hinzugefügt",
    },
    actions: {
      save: "Speichern",
      cancel: "Abbrechen",
      edit: "Bearbeiten",
      remove: "Entfernen",
    },
  },
  table: {
    machines: {
      headers: {
        name: "Name",
        amount: "Menge",
        duration: "Dauer",
        unit: "Einheit",
      },
    },
    materials: {
      headers: {
        name: "Name",
        amount: "Menge",
        unit: "Einheit",
      },
    },
    additional_efforts: {
      headers: {
        name: "Name",
        amount: "Menge",
        unit: "Einheit",
      },
    },
    users: {
      headers: {
        firstname: "Vorname",
        lastname: "Nachname",
        duration: "Dauer",
        position: "Rolle",
      },
    },
  },
  tabs: {
    general: "Allgemein",
    machines: "Maschinen",
    materials: "Materialien",
    additional_efforts: "Zusätzliche Leistungen",
    users: "Personal",
    files: "Dateien",
    activity: "Protokoll",
  },
  // Der Dialog hinter dem Zahnrad des Tag-Felds einer Stundenlohnarbeit (LewHourlyWageReportTagOverview).
  // Ein Tag ist nur sein Name, er wird angelegt oder gelöscht, nicht umbenannt.
  tag_catalogue: {
    title: "Tags verwalten",
    subtitle: "Die Tags des ganzen Betriebs für [[hwr.pl]].",
    search: "Tags durchsuchen",
    add: "Tag hinzufügen",
    empty: "Noch keine Tags angelegt.",
    no_match: "Kein Tag passt zur Suche.",
    count: "{count} Tag | {count} Tags",
    name: "Name",
    name_taken: "Einen Tag mit diesem Namen gibt es schon.",
    delete_title: "Tag löschen",
    delete_text: 'Der Tag „{name}" wird aus der Auswahl gelöscht. [[hwr.pl]], die ihn schon tragen, behalten ihn.',
  },
  advanced_search: {
    advanced: "Erweiterte Suche",
    add_component: "Komponente hinzufügen",
    search: "Suchen",
    clear: "Zurücksetzen",
    empty_title: "Noch keine Filter",
    empty: "Füge eine Bedingung hinzu, um eine eigene Suche über deine [[hwr.pl]] aufzubauen.",
    tags_included: "Tags inbegriffen",
    start_date_is: "Ausführungsdatum Ist",
    start_date_between_start: "Ausführungsdatum Start",
    start_date_between_end: "Ausführungsdatum Ende",
    print_date_is: "Druckdatum Ist",
    print_date_between_start: "Druckdatum Start",
    print_date_between_end: "Druckdatum Ende",
    last_modified_date_is: "Zuletzt Bearbeitet Datum Ist",
    last_modified_date_between_start: "Zuletzt Bearbeitet Datum Start",
    last_modified_date_between_end: "Zuletzt Bearbeitet Datum Ende",
    description_is: "Beschreibung beinhaltet",
    create_date_is: "Erstelldatum Ist",
    create_date_between_start: "Erstelldatum Start",
    create_date_between_end: "Erstelldatum Ende",
    bundled_component_add: "Komponente hinzufügen",
    remove_condition: "Bedingung entfernen",
    toggle_logic: "UND / ODER umschalten",
    pick_subtitle: "Wähle ein Filterkriterium",
    pick_group_fields: "Felder",
    pick_group_dates: "Daten",
    pick_group_grouping: "Gruppierung",
    pick_description: "Beschreibung beinhaltet",
    pick_tags: "Tags",
    pick_start_date: "Ausführungsdatum",
    pick_start_date_range: "Ausführungszeitraum",
    pick_print_date: "Druckdatum",
    pick_print_date_range: "Druckzeitraum",
    pick_create_date: "Erstelldatum",
    pick_create_date_range: "Erstellzeitraum",
    pick_last_modified: "Zuletzt bearbeitet",
    pick_last_modified_range: "Zeitraum zuletzt bearbeitet",
    pick_group: "Bedingungsgruppe",
  },
  file: {
    // Das Häkchen einer Anhangzeile entscheidet, ob die Datei in den PDF-Druck eingebettet wird.
    // Beide Zustände sind ausformuliert: das Icon kippt stumm, die Beschriftung ist das Einzige,
    // was den aktuellen Zustand benennt. Im Dateidialog steht dasselbe Häkchen mit print_label.
    print_label: "Im PDF-Druck anzeigen",
    print_included: "Datei wird im PDF-Druck mit angezeigt",
    print_excluded: "Datei wird im PDF-Druck nicht angezeigt",
    print_unsupported: "Dateiformat wird im PDF-Druck nicht unterstützt",
    // Nur im Dateidialog: der Druck verkleinert Bilder und die Fotos in PDFs, angehakt nicht.
    print_original_label: "In Originalqualität drucken",
    print_original_help:
      "Bilder und PDFs werden im Druck verkleinert, damit der Bericht per E-Mail versendet werden kann. Angehakt wird die Datei unverändert eingebettet.",
  },
  validation: {
    atLeastOneUserOrMachineOrMaterialOrEffort:
      "Mindestens eine Maschine/Material/Personal/Zusätzl. Leistung hinzufügen",
  },
}
